// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HcUY","selected":"styles_selected__3KTa3"};